module.exports = __webpack_public_path__ + "media/bootstrap-icons/align-center-c3f2b0f8.svg";